import { useStorage } from '@/utils/storage.js';
import { useMenuListStore } from '@/stores/index.js';
import { reactive } from 'vue'; 
import { forEach } from 'lodash';

import { useDefaultRoutes } from './defaultRoutes.js'
const defaultRoutes = useDefaultRoutes()

//import Layout from '@/parts/layout/Index.vue';
const Layout = () => import('@/parts/layout/IndexMultiple.vue');
//import Empty from '@/parts/layout/Empty.vue';
const Empty = () => import('@/parts/layout/Empty.vue');

// 取到 /views 目录下的所有的 .vue 页面文件
const views = import.meta.glob('/src/views/**/*.vue');

const isJson = (str) => {
	try {
		JSON.parse(str);
		return true;
	} catch (e) {
		return false;
	}
}

const generateRoutes = (menuList, parentName = '') => {
	return menuList.filter(item => {
		return item.type <= 1 // 筛选出菜单目录和菜单链接
	}).map(item => {
		const { name, url, default_url, path, query, type, title } = item
		const newName = parentName ? `${parentName}-${name}`:`${name}`
		const route = {
			name: newName, 
			path: url || '#',
			meta: { title }, 
			children: item.children ? generateRoutes(item.children, newName) : []
		}
		
		if(type == 0) {
			route['redirect'] = default_url
			route['component'] = Empty
		}
		else {
			const filePath = path.startsWith('/') ? path.substr(1) : path
			route['component'] = views[`/src/${filePath}`]
			
			if(query && isJson(query)) {
				route['props'] = JSON.parse(query)
			}
		}
		return route;
	})
}

export const useDynamicRoutes = () => {
	// 取第一个路由
	const homeRoute = defaultRoutes[0];
	
	const menuList = useStorage('local').get('menu_list') || [];
	if(menuList) {
		// defaultRoutes[0] 是路由表的第一个项（/）
		const routes = generateRoutes(menuList);
		forEach(routes, item => {
			const isExist = homeRoute.children.some(route => {
				return route.name == item.name
			})
			
			if(!isExist) {
				homeRoute.children.unshift(item)
			}
		})
	}
	
	return homeRoute
}

// 未登录时候，用默认路由
export const useAppRoutes = () =>{
	const routes = useDynamicRoutes();
	defaultRoutes[0] = routes;
	return defaultRoutes;
}
